exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Value-CellClass[data-v-33c85fab]{font-size:16px}.Title-CellClass[data-v-33c85fab]{text-align:left;font-size:.5rem;line-height:.875rem}.btn-test[data-v-33c85fab]{margin-top:1rem}", ""]);

// exports
